<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$cashMultiple"
				start
			/>
			<translate>Invoices</translate>
			<v-spacer />
			<v-btn
				v-can="'invoice.create'"
				color="primary"
				variant="flat"
				prepend-icon="$plus"
				@click="window.location.href=`/bo/invoices/add?order_id=${orderId}`"
			>
				<translate>Add Invoice</translate>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-alert
				v-if="orderReversed"
				type="error"
				variant="outlined"
				border="start"
			>
				<translate>Customer has reversed.</translate>
			</v-alert>

			<model-backend-table
				density="compact"
				:endpoint="`/api/v0/invoices?order_id=${orderId}`"
				:headers="tableHeaders"
				:items-per-page="100"
				:items-per-page-options="[100]"
				:item-class="itemBackground"
			>
				<template #item.identifier="{ item }">
					<a :href="`/bo/invoices/view?id=${item.id}`">
						{{ item.identifier }}
					</a>
				</template>
				<template #item.type="{ item }">
					<img
						v-if="item.type === 'Manual'"
						src="/bo/images/icons/user.png"
					>
					<img
						v-else
						src="/bo/images/icons/computer.png"
					>
				</template>
				<template #item.amount="{ item }">
					<div :class="[item.amount < 0 ? 'negative-currency' : '']">
						{{ transformToCurrency(item.amount) }}
					</div>
				</template>
				<template #item.status="{ item }">
					<img
						v-if="item.status === 'due_not_paid'"
						:title="$gettext(invoiceStatuses['not_paid'].message)"
						:src="invoiceStatuses['not_paid'].image"
					>
					<img
						v-if="item.status === 'processing'"
						:title="$gettextInterpolate(invoiceStatuses[item.status].message, {date: item.automatedProcessingDate})"
						:src="invoiceStatuses[item.status].image"
					>
					<img
						v-else
						:title="$gettext(invoiceStatuses[item.status].message)"
						:src="invoiceStatuses[item.status].image"
					>
				</template>
				<template #item.description=" {item}">
					<div v-if="!item.startDate && !item.endDate">
						{{ item.description }}
					</div>
				</template>
			</model-backend-table>
		</v-card-text>
	</v-card>
</template>

<script>
import ModelBackendTable from '../molecules/ModelBackendTable.vue';

export default {
	name: 'OrderInvoicesTable',
	components: {
		ModelBackendTable
	},
	props: {
		orderId: {
			required: true,
			type: String
		},
		orderReversed: {
			required: false,
			type: Boolean,
			default: false,
		},
		invoiceId: {
			required: false,
			type: String,
			default: null
		}
	},

	data () {
		return {
			invoiceStatuses:
				{
					'processing_at_bank': {
						message: 'Debt collection is processed',
						image: '/bo/images/icons/hourglass.png'
					},
					'paid_not_received': {
						message: 'Invoice paid, not received',
						image: '/bo/images/icons/tick.png'
					},
					'paid_intra_invoice': {
						message: 'Paid intra-invoice',
						image: '/bo/images/icons/arrow_undo.png'
					},
					'refunded': {
						message: 'Refunded invoice',
						image: '/bo/images/icons/chart_bar_link.png'
					},
					'paid': {
						message: 'Invoice paid',
						image: '/bo/images/icons/tick.png'
					},

					'not_paid': {
						message: 'Invoice not yet paid',
						image: '/bo/images/icons/cross.png'
					},
					'due_not_paid': {
						message: 'Payment term expired and invoice not yet paid',
						image: '/bo/images/icons/error.png'
					},
					'processing': {
						message: 'Debt collection was offered to the bank on %{date}.',
						image: '/bo/images/icons/time.png'
					}
				},
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Invoice Number'), value: 'identifier', sortable: false,
				},
				{
					title: this.$gettext('Start'), value: 'startDate', sortable: false,
				},
				{
					title: this.$gettext('End'), value: 'endDate', sortable: false,
				},
				{
					title: this.$gettext('Amount'), value: 'amount', sortable: false,
				},
				{
					title: this.$gettext('Type'), value: 'type', sortable: false,
				},
				{
					title: this.$gettext('Status'), value: 'status', sortable: false,
				},
				{
					title: this.$gettext('Description'), value: 'description', sortable: false,
				},
			];
		}
	},

	methods: {
		/**
		 * Highlight current invoice
		 *
		 * @param {object} item
		 * @returns {string} active if current invoice
		 */
		itemBackground: function (item) {
			return item.id === Number(this.invoiceId) ? 'active' : '';
		},

		/**
		 * @param {string} amount
		 * @returns {string}
		 */
		transformToCurrency (amount) {
			const eurFormatter = new Intl.NumberFormat('nl', {
				style: 'currency',
				currency: 'EUR',
			});

			return eurFormatter.format(Number(amount));
		},
	},


};
</script>
